<template>
  <div class="breadcrumb">
    <div v-if="!hideBackBtn">
      <div v-if="isHistoryBack" class="back-option anchor" @click="backClick">
        <svgicon name="arrow-down" class="icon" width="17" height="17" :original="true" />
      </div>
      <div v-else class="back-option">
        <router-link :to="{ name: back}">
          <svgicon name="arrow-down" class="icon" width="17" height="17" :original="true" />
        </router-link>
      </div>
    </div>
    <div class="dropdown">
      <div class="dropdown-selected">
        {{message}}
      </div>
    </div>
    <div class="dropdown-status" v-if="indentStatus === 8"> <!-- Hard-coded because statusUtil not available -->
      <div class="status-box">
        {{status}}
      </div>  
      <svgicon name="icon-transit" class="icon-image" width="17" height="17"/>
    </div>
     <div class="action-button">
     <div v-if="showExport">
         <button class="btn btn-secondary" @click="$emit('export')">Export</button>
       </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['back', 'message', 'isHistoryBack', 'showExport', 'hideBackBtn', 'status', 'indentStatus'],
  methods: {
    backClick() {
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="scss">
  .anchor {
    cursor: pointer;
  }
  .dropdown-status {
  color: #EE1C0C;
  float: right;
  padding-right: 10px;
  margin-top: 10px;
  font-size: 1.2rem;
  letter-spacing: 1.17px;
  display: flex;
  .status-box {
    align-items: center;
    border: 1px solid rgba(255, 230, 234, 0.7);
    background-color: rgba(255, 230, 234, 0.7);
    padding: 5px 10px;
    border-radius: 4px;
    margin-right: 5px;
  }
  .icon-image {
    margin-top: 4px;
  }
  }
</style>
